import { useMutation, useQueryClient } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

interface CreateTicketPayload {
    title: string;
    description: string;
    user_id: string;
}

export const createTicket = async (payload: CreateTicketPayload) => {
    try {
        const response = await Axios.post(`/tickets/`, payload);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useCreateTicket = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createTicket,
        onSuccess: () => {
            // Invalidate and refetch relevant queries if needed
            queryClient.invalidateQueries({ queryKey: ["get-tickets"] }); // Invalidate the tickets query to refresh the list
        },
    });
};